import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import InnerLoader from './../../APP/COMPONENTS/InnerLoader';
import * as helpers from "./../../APP/HELPERS/functions"

function mapStateToProps(state) {
    return {};
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class LoginForm extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);

        this.state = {
            SENDING: false,
            EMAIL: '',
            PASSWORD: '',
            VIEW: 'login',
            ERROR: false
        };
    }

    componentDidMount()
    {
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
    }

    recordData = (input, type) => 
    {
        this.setState({[type]: input.target.value});
    }

    renderLoginButton()
    {
        if (this.isReadyToLogin()) {
            if (this.state.SENDING) {
                return <button className="default">Входим ...</button>;
            } else {
                return <button className="default" onClick={() => this.login()}>Войти</button>;
            }
        } else {
            return <button className="default inactive">Войти</button>
        }
    }

    renderRecoverButton()
    {
        if (this.isReadyToRecover()) {
            if (this.state.SENDING) {
                return <button className="default">Восстанавливаем ...</button>;
            } else {
                return <button className="default" onClick={() => this.recover()}>Восстановить</button>;
            }
        } else {
            return <button className="default inactive">Восстановить</button>
        }
    }

    isReadyToRecover = () =>
    {
        if (this.state.EMAIL.length > 3) {
            return true;
        }

        return false;
    }

    isReadyToLogin = () =>
    {
        if ((this.state.EMAIL.length > 3) && (this.state.PASSWORD.length > 3)) {
            return true;
        }

        return false;
    }

    validateEmail = (email) =>
    {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    login = async () =>
    {
        if (!this.state.SENDING) {
            try {
                this.setState({SENDING: true});

                let SEND_DATA = {
                    login:      this.state.EMAIL,
                    password:   this.state.PASSWORD
                };

                let data = await Request(SEND_DATA,'auth/login');
                if (data !== false) {
                    this.props.doAuth(data);
                    this.props.openLogin(false)
                    this.setState({SENDING: false, ERROR: false});
                } else {
                    this.setState({SENDING: false, ERROR: true});
                }
            } catch (error) {
                this.setState({SENDING: false});
            }
        }
    }

    recover = async () =>
    {
        if (!this.state.SENDING) {
            try {
                this.setState({SENDING: true});

                let SEND_DATA = {
                    login:      this.state.EMAIL
                };

                let data = await Request(SEND_DATA,'auth/recover');
                if (data !== false) {
                    this.setState({VIEW: 'login', SENDING: false, ERROR: false});
                } else {
                    this.setState({SENDING: false, ERROR: true});
                }
            } catch (error) {
                this.setState({SENDING: false});
            }
        }
    }

    renderForm = () =>
    {
        if (this.state.VIEW == 'login') {
            return (
                <div>
                    <div className="login_head">
                        Авторизация
                    </div>

                    <div className="login_form">
                        <input 
                            placeholder="Логин"
                            type="text"
                            onChange={(text) => this.recordData(text, 'EMAIL')}
                            className={ this.state.ERROR ? 'errorInput' : ''}
                        />
                        <input 
                            placeholder="Пароль"
                            type="password"
                            onChange={(text) => this.recordData(text, 'PASSWORD')}
                            className={ this.state.ERROR ? 'errorInput' : ''}
                        />

                        {this.renderLoginButton()}

                        <a className="recover_button" onClick={() => this.setState({VIEW: 'recover', ERROR: false})}>
                            Восстановить пароль
                        </a>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="login_head">
                        Восстановление пароля
                    </div>

                    <div className="login_form">
                        <input 
                            placeholder="Логин"
                            type="text"
                            onChange={(text) => this.recordData(text, 'EMAIL')} 
                            className={ this.state.ERROR ? 'errorInput' : ''}
                        />

                        {this.renderRecoverButton()}

                        <a className="recover_button" onClick={() => this.setState({VIEW: 'login', ERROR: false})}>
                            К авторизации
                        </a>
                    </div>
                </div>
            );
        }
    }

    render()
    {
        return (
            <div className="modal-content">
                <div className="login_first_row">
                    <img src="/system_images/logo_orange.png" />
                    <div className="login_first_text_holder">
                        <div>Ecomarket.ru</div>
                        <div>поставщики</div>
                    </div>
                </div>

                {this.renderForm()}
            </div>
        );
    }

}

export default connect(
    mapStateToProps, mapDispatchToProps
)(LoginForm);